import React from 'react'
import styled from 'styled-components'
import { Colors } from '../../configs/styled.config'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: ${Colors['pale-grey']};
    text-align: center;
    padding: 24px;
`

const Icon = styled.div`
    font-size: 72px;
    margin-bottom: 24px;
`

const Title = styled.h1`
    font-family: Merriweather-Light, sans-serif;
    font-size: 28px;
    color: ${Colors['slate']};
    margin: 0 0 12px;
`

const Subtitle = styled.p`
    font-family: Merriweather-Light, sans-serif;
    font-size: 16px;
    color: ${Colors['slate-light']};
    max-width: 480px;
    line-height: 1.6;
    margin: 0 0 32px;
`

const RetryButton = styled.button`
    background-color: ${Colors['primary-digiauto']};
    color: ${Colors['white']};
    border: none;
    border-radius: 4px;
    padding: 12px 32px;
    font-family: Merriweather-Light, sans-serif;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }
`

const MaintenancePage = () => {
    const handleRetry = () => {
        window.location.reload()
    }

    return (
        <Wrapper>
            <Icon>🔧</Icon>
            <Title>Em manutenção</Title>
            <Subtitle>
                O serviço está temporariamente indisponível. Estamos a trabalhar
                para resolver o problema o mais rapidamente possível. Por favor,
                tente novamente em breve.
            </Subtitle>
            <RetryButton onClick={handleRetry}>Tentar novamente</RetryButton>
        </Wrapper>
    )
}

export default MaintenancePage
